import * as React from 'react';

export default class KeyHandler extends React.Component {
	constructor(props) {
		super(props);
		this.keyFunction = this.keyFunction.bind(this);
	}
	keyFunction(event) {
		const { enter, esc, plus, minus, navigation } = this.props;
		if (!!navigation && !navigation.isFocused()) return;
		var cancel;
		if (event.keyCode === 27 && esc) cancel = esc() || true;
		if (event.keyCode === 13 && enter) cancel = enter() || true;
		if (event.key == '+' && plus) cancel = plus() || true;
		if (event.key == '-' && minus) cancel = minus() || true;
		if (cancel) {
			event.preventDefault();
			return false;
		}
	}
	componentDidMount() {
		document.addEventListener('keydown', this.keyFunction, false);
	}
	componentWillUnmount() {
		document.removeEventListener('keydown', this.keyFunction, false);
	}
	render() {
		return null;
	}
}
